<iframe style="margin: 10px 0" frameborder="0" border="0" width="100%" height="600" 
  src="https://app.powerbi.com/view?r=eyJrIjoiNmUzNTJjMGMtZDdjOS00MDVlLWFhNzYtZWRkMTY1N2FmZmQ2IiwidCI6IjY3N2Q0MGUyLTA2ZmEtNGM0Yi1iN2UyLTM4NWQ4NjNjYjczOSJ9"
  ></iframe>
<div class="rodapeMapa"></div>